import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getClassNames } from './index.classNames';
import Scrollbars from 'react-custom-scrollbars-2';
import { Checkbox, ComboBox, DatePicker, DirectionalHint, Dropdown, FontIcon, FontSizes, IDropdownOption, IPersonaProps, IRenderFunction, ITag, ITextFieldProps, KeyCodes, Label, NormalPeoplePicker, SearchBox, Separator, Spinner, SpinnerSize, TagPicker, TextField, Toggle, TooltipHost, ValidationState } from '@fluentui/react';
import { CommandActions } from '../../../redux/actions/filters';
import { CommandActions as DocumentsCommandActions} from '../../../redux/actions/documents';
import _, { filter } from 'lodash';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Tag, WithContext as ReactTags } from 'react-tag-input';
import debounce from 'debounce';
import { getFilterAgileNumber, getFilterClientNumber, getFilterCommented, getFilterDiscipline, getFilterDocType, getFilterDocumentNumber, getFilterEngPhase, getFilterEntity, getFilterFolder, getFilterFrom, getFilterIsForInternalUse, getFilterPbs, getFilterPurpose, getFilterPwFilename, getFilterRevision, getFilterSheet, getFilterShowAllVersions, getFilterStatus, getFilterTdNumber, getFilterTo, getFilterTransmittalNumber, getFilterType, getSelectedFilter, getStatus, getFilterPartner, getFilterCustomer, getFilterTitleLine4Pl, getFilterTitleLine5Pl, getFilterTitleLine6Pl, getFilterGeneric, getFilterIgnorePurposes, getFilterPartnerNumber, getFilterApprovalDate, getFilterSupplier, getFilterSupplierDocumentNumber, getFilterTdSubject } from '../../../redux/reducers/filters';
import { Type } from '../../../models/type';
import { Status, StatusEnum } from '../../../models/status';
import { formatDate, getTypesDropdownOptions, getEngPhaseDropdownOptions, getEntityDropdownOptions, getHistoryName, getPurposeDropdownOptions, getDisciplineDropdownOptions, getDocTypesDropdownOptions, getContextualFilters, getStakeHoldersDropdownOptions, getPublicationDropdownOptions } from '../../../utils/functions';
import { FilterComponent, Filters } from '../../../models/filters';
import { ExternalRoleActionsType, FiltersType, getTheme, InternalRoleActionsType, isExternalApp } from '../../../utils/costants';
import { NumericFormat } from 'react-number-format';
import { getTypes, getEngPhases, getEntities, getPurposes, getStatusValues, getDisciplines, getPbs, getFolders, getPublications, getStakeHolders, getPublicationsList } from '../../../redux/reducers/sharedData';
import { getLoader } from '../../../redux/selectors/loader';
import { Purpose } from '../../../models/purpose';
import { Entity } from '../../../models/entity';
import { EngPhase } from '../../../models/engPhase';
import { Discipline } from '../../../models/discipline';
import { Popup as HierarchyExplorer } from '@pwbapps/hierarchyexplorer';
import { Pbs } from '../../../models/pbs';
import CornerArrow from '../../../images/cornerArrow.png';
import { getField } from '../../reduxFields/reduxGeneralField';
import { DocType } from '../../../models/docType';
import { getStatusDropdownOptions } from '../../../utils/statusFunctions';
import { getSelectedProject, getSelectedProjectCustomers, getSelectedProjectPartners, getSelectedProjectSuppliers } from '../../../redux/selectors/project';
import { Project } from '../../../models/project';
import { Folder } from '../../../models/folder';
import { StakeHolder } from '../../../models/stakeHolder';
import { getSelectedProjectUserActions } from '../../../redux/selectors/auth';
import {Actions as ModalActions} from '@pwbapps/genericdialog';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { getDarkModeEnabled } from '../../../redux/reducers/project';
import { getSelectedProjectDaysToApproval } from '../../../redux/selectors/project';

const AgileNumberReader = getField((state: any) => getFilterAgileNumber(state));
const SheetReader = getField((state: any) => getFilterSheet(state));
const RevisionReader = getField((state: any) => getFilterRevision(state));
const ClientNumberReader = getField((state: any) => getFilterClientNumber(state));
const TdNumberReader = getField((state: any) => getFilterTdNumber(state));
const TransmittalNumberReader = getField((state: any) => getFilterTransmittalNumber(state));
const PwFilenameReader = getField((state: any) => getFilterPwFilename(state));
const StatusReader = getField((state: any) => getFilterStatus(state));
const TypeReader = getField((state: any) => getFilterType(state));
const PartnerReader = getField((state: any) => getFilterPartner(state));
const CustomerReader = getField((state: any) => getFilterCustomer(state));
const PurposeReader = getField((state: any) => getFilterPurpose(state));
const EntityReader = getField((state: any) => getFilterEntity(state));
const EngPhaseReader = getField((state: any) => getFilterEngPhase(state));
const DocTypeReader = getField((state: any) => getFilterDocType(state));

const FolderReader = getField((state: any) => getFilterFolder(state));
const IsForInternalUseReader = getField((state: any) => getFilterIsForInternalUse(state));
const ShowAllVersionsReader = getField((state: any) => getFilterShowAllVersions(state));
const CommentedReader = getField((state: any) => getFilterCommented(state));
const TdSubjectReader = getField((state: any) => getFilterTdSubject(state));
const TitleLine4PlReader = getField((state: any) => getFilterTitleLine4Pl(state));
const TitleLine5PlReader = getField((state: any) => getFilterTitleLine5Pl(state));
const TitleLine6PlReader = getField((state: any) => getFilterTitleLine6Pl(state));
const GenericReader = getField((state: any) => getFilterGeneric(state));
const IgnorePurposesReader = getField((state: any) => getFilterIgnorePurposes(state));
const PartnerNumberReader = getField((state: any) => getFilterPartnerNumber(state));
const ApprovalDateReader = getField((state: any) => getFilterApprovalDate(state));
const SupplierReader = getField((state: any) => getFilterSupplier(state));
const SupplierDocumentNumberReader = getField((state: any) => getFilterSupplierDocumentNumber(state));

export interface FiltersState { isLoadingPics: boolean }
export interface FiltersProps extends RouteComponentProps, WithTranslation { 
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    isCallout?: boolean,
    selectedFilter?: FiltersType,
    statusValues: Status[],
    types: Type[],
    purposes: Purpose[],
    entities: Entity[],
    engPhases: EngPhase[],
    disciplines: Discipline[],
    from?: Date,
    to?: Date,
    documentNumber: string[],
    pbs: Pbs[],
    discipline?: Discipline
    selectedProject?: Project,
    folders: Folder[],
    partners: StakeHolder[],
    customers: StakeHolder[],
    suppliers: StakeHolder[],
    publicationsList: number[],
    loadingStatus: boolean,
    loadingTypes: boolean,
    loadingPurposes: boolean,
    loadingEntities: boolean,
    loadingEngPhases: boolean,
    loadingDisciplinesAndDocTypes: boolean,
    loadingPbs: boolean,
    loadingFolders: boolean,
    loadingStakeHolders: boolean,
    darkModeEnabled: boolean,
    showAllDocs: boolean,
    daysToApproval: number,
    pbsFilter?: Pbs[],
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    setDocumentNumber: typeof CommandActions.setDocumentNumber,
    setAgileNumber: typeof CommandActions.setAgileNumber,
    setSheet: typeof CommandActions.setSheet,
    setRevision: typeof CommandActions.setRevision,
    setClientNumber: typeof CommandActions.setClientNumber,
    setTdNumber: typeof CommandActions.setTdNumber,
    setTransmittalNumber: typeof CommandActions.setTransmittalNumber,
    setStatus: typeof CommandActions.setStatus,
    setType: typeof CommandActions.setType,
    setPurpose: typeof CommandActions.setPurpose,
    setEntity: typeof CommandActions.setEntity,
    setEngPhase: typeof CommandActions.setEngPhase,
    setFrom: typeof CommandActions.setFrom,
    setTo: typeof CommandActions.setTo,
    setPwFilename: typeof CommandActions.setPwFilename,
    setCommented: typeof CommandActions.setCommented,
    setDiscipline: typeof CommandActions.setDiscipline,
    setDocType: typeof CommandActions.setDocType,
    setPbs: typeof CommandActions.setPbs,
    setFolder: typeof CommandActions.setFolder,
    setIsForInternalUse: typeof CommandActions.setIsForInternalUse,
    setShowAllVersions: typeof CommandActions.setShowAllVersions,
    setPartner: typeof CommandActions.setPartner,
    setPartnerNumber: typeof CommandActions.setPartnerNumber,
    setCustomer: typeof CommandActions.setCustomer,
    openGenericModal: typeof ModalActions.CommandActions.openModal,
    setTDSubject: typeof CommandActions.setTDSubject,
    setTitleLine4Pl: typeof CommandActions.setTitleLine4Pl,
    setTitleLine5Pl: typeof CommandActions.setTitleLine5Pl,
    setTitleLine6Pl: typeof CommandActions.setTitleLine6Pl,
    setGeneric: typeof CommandActions.setGeneric,  
    setIgnorePurposes: typeof CommandActions.setIgnorePurposes,
    setApprovalDate: typeof CommandActions.setApprovalDate,
    setSupplier: typeof CommandActions.setSupplier,
    setSupplierDocumentNumber: typeof CommandActions.setSupplierDocumentNumber,
}

class FiltersClass extends React.Component<FiltersProps & RouteComponentProps> {
    debouncedFetchDocuments: any
    
    constructor(props: FiltersProps) {
        super(props);

        this.debouncedFetchDocuments = debounce((e: any, value: string) => {
            const {fetchDocuments} = this.props;
            fetchDocuments({});
		}, 500);

        this.state = {
            isLoadingPics: false
        }
    }

    _onRenderCategoryOption = (option?: IDropdownOption): JSX.Element => {
        const { isCallout, darkModeEnabled } = this.props;
        const styles = getClassNames(isCallout ? true : false, getTheme(darkModeEnabled));
        return (
            <div key={(option) ? option.key : undefined} className={styles.dropDownItem}>
                {option && (option as any).icon && <FontIcon style={{marginRight: 10, fontSize: FontSizes.xLarge, color: (option) ? (option as any).color : undefined}} iconName={(option) ? (option as any).icon : undefined} />}
                <span>{(option) ? option.text : undefined}</span>
            </div>     
        );
    };

    _onRenderCategoryTitle = (options?: IDropdownOption[]): JSX.Element => {
        const option = (options && options.length > 0) ? options[0] : undefined;
        return this._onRenderCategoryOption(option);
    };

    addDocumentNumberTag = (tag: Tag) => {
        const { setDocumentNumber, documentNumber } = this.props;
        setDocumentNumber({value: (tag && tag.id) ? [...documentNumber, tag.id] : documentNumber});
        this.debouncedFetchDocuments();
    }
    removeDocumentNumberTag = (index: number) => {
        const { setDocumentNumber, documentNumber } = this.props;
        setDocumentNumber({value: _.filter(documentNumber, (dn, i: number) => index !== i)});
        this.debouncedFetchDocuments();
    }

    setFolderValueFunction = (item?: any, checked?: any) =>{
        const { setFolder } = this.props;
        if(item)
            setFolder({value: (checked) ? item : undefined});
        else 
            setFolder({value: undefined});
        this.debouncedFetchDocuments();
    }

    onRenderFolderSuffix: IRenderFunction<ITextFieldProps> = (props, defaultRender) => {
        const { t } = this.props;
        return (      
            <FolderReader>{(reduxValue?: Folder) =>   
                <TooltipHost directionalHint={DirectionalHint.rightCenter} content={(reduxValue) ? t("Remove Folder") : ""}>
                    <div onClick={(reduxValue) ? (e) => {this.setFolderValueFunction(undefined); e.stopPropagation()} : () => {}}>
                        <FontIcon iconName={"Cancel"} style={{cursor: (reduxValue) ? "pointer" : "default" }}  /> 
                    </div>
                </TooltipHost>          
            }</FolderReader>  
        )
    };

    getGenericComponent = (): FilterComponent => {
        const { setGeneric, t } = this.props;
        let genericComponent: FilterComponent = {
            id: '_generic',
            component:
                <GenericReader>{(reduxValue?: string) =>   
                    <TextField 
                        key={'_generic'}
                        label={t('Generic search')}
                        autoComplete={'off'} 
                        value={reduxValue || ''} 
                        onChange={(e, value) => { 
                            setGeneric({value});
                            this.debouncedFetchDocuments();
                        }}
                        styles={{root: {marginLeft: 5, minWidth: 260}}}
                    />       
                }</GenericReader>    
        };
        return genericComponent;
    }


    getMainFilters = (): FilterComponent[] => {
        const { isCallout, history, selectedFilter, statusValues, customers, loadingStatus, from, to, documentNumber, loadingFolders, folders, selectedProject, userProjectActions, t, darkModeEnabled, publicationsList, loadingPurposes, purposes, showAllDocs, loadingStakeHolders,
                partners, daysToApproval, suppliers, setFrom, setTo, setCustomer, setStatus, setAgileNumber, setSheet, setRevision, setClientNumber, setTdNumber, setTransmittalNumber, openGenericModal, setTitleLine4Pl, setTitleLine5Pl, setTDSubject,
                setTitleLine6Pl, setPurpose, setPartner, setPartnerNumber, setApprovalDate, setSupplier, setSupplierDocumentNumber, pbs, loadingPbs, loadingDisciplinesAndDocTypes, setDiscipline, setDocType, disciplines, discipline, pbsFilter } = this.props;
        const historyName = getHistoryName(history);
        const styles = getClassNames(isCallout ? true : false, getTheme(darkModeEnabled));
        let status_options: {key: number, text: string, icon: string, color: string}[] = [...getStatusDropdownOptions(statusValues, historyName)];
        let purposes_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getPurposeDropdownOptions(purposes, historyName, showAllDocs)];
        const documentNumberTags: Tag[] = (documentNumber.length > 0) ? _.map(documentNumber, dn => {return {id: dn, text: dn}}) : [];
        let publication_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getPublicationDropdownOptions(publicationsList)];
        let partner_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getStakeHoldersDropdownOptions(partners)];
        let supplier_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getStakeHoldersDropdownOptions(suppliers)];
        let disciplines_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getDisciplineDropdownOptions(disciplines)];
        let docType_options: {key: number, text: string}[] = (disciplines.length > 0 && discipline) ? [{key: -1, text: 'None'}, ...getDocTypesDropdownOptions(discipline)] : [];
        let customer_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getStakeHoldersDropdownOptions(_.filter(customers, c => c.isActive))];

        let statusComponent: FilterComponent = {
            id: 'status',
            component:
                <StatusReader>{(reduxValue: Status[]) =>   
                    <div style={{marginLeft: 5}}>
                        {!loadingStatus && <Label>{t('Status')}</Label>}
                        {loadingStatus && 
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <Label style={{marginRight: 10}}>{t('Status')}</Label>
                                <Spinner size={SpinnerSize.small}/>
                            </div>
                        }
                        <ComboBox
                            multiSelect
                            key={'status'}
                            placeholder={t('Select a status') + '...'}
                            disabled={loadingStatus}
                            options={status_options}
                            title={_.join(_.map(reduxValue, s => s.description), ', ')}
                            onChange={(e, value) => {
                                const alredyIn = (value) ? _.find(reduxValue, s => s.id  === value.key) : undefined;
                                setStatus({value: (!alredyIn) ? [...reduxValue, _.find(statusValues, s => value && s.id === value.key) as Status] : [..._.filter(reduxValue, s => alredyIn && s.id !== alredyIn.id)]});
                                this.debouncedFetchDocuments();
                            }}
                            selectedKey={(reduxValue.length > 0) ? _.map(reduxValue, s => s.id as number) : []}    
                            onRenderOption={this._onRenderCategoryOption}
                            useComboBoxAsMenuWidth                          
                            //onRenderTitle={this._onRenderCategoryTitle}                             
                            styles={{root: {minWidth: 260}}}
                        />
                    </div>
                }</StatusReader> 
        };
        let datesComponent: FilterComponent[] = [
            {
                id: 'from',
                component:  
                    <DatePicker
                        label={t('From')}
                        value={from}
                        maxDate={(to) ? to : undefined}
                        onSelectDate={(date) => {
                            setFrom({value: (date) ? date : undefined});
                            this.debouncedFetchDocuments();
                        }}
                        formatDate={formatDate}
                        styles={{root: {marginLeft: 5, minWidth: isCallout ? 260 : undefined}}}
                    />                  
            },
            {
                id: 'to',
                component:  
                    <DatePicker
                        label={t('To')}
                        value={to}
                        minDate={(from) ? from : undefined}
                        onSelectDate={(date) => {
                            setTo({value: (date) ? date : undefined});
                            this.debouncedFetchDocuments();
                        }}
                        formatDate={formatDate}
                        styles={{root: {marginLeft: 5, minWidth: isCallout ? 260 : undefined}}}
                    />                  
            },
        ];
        let folderComponent: FilterComponent =  
        {
            id: 'folder',
            component:
            <FolderReader>{(reduxValue?: Folder) =>   
                <HierarchyExplorer 
                    readOnly={loadingFolders}
                    title={"Folder selector"}
                    items={folders}
                    onSelect={(item, checked) => this.setFolderValueFunction(item, checked)}                                             
                    selected={(reduxValue) ? [reduxValue.id] : []}
                    selectedProperty={"id"}
                    isSelectable={() => {return true}}>
                    {(ref, onClick) => (
                        <div style={{marginLeft: 5}}>
                            {!loadingFolders && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>Folders</Label>
                                    <FontIcon iconName={'Edit'} style={{color: getTheme(darkModeEnabled).palette.themePrimary, fontSize: FontSizes.large, cursor: 'pointer' }} onClick={() => {openGenericModal({id: 'folder', contextItem: {folder: reduxValue, isAdding: false, isRemoving: false}})}} />
                                </div>
                            }
                            {loadingFolders && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>Folders</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <div ref={ref} onClick={onClick} onFocus={onClick}>
                                <TextField 
                                    readOnly={true} 
                                    autoComplete={'off'} 
                                    value={(reduxValue) ? reduxValue.folderName : undefined} 
                                    title={(reduxValue) ? reduxValue.folderName : undefined} 
                                    onRenderSuffix={this.onRenderFolderSuffix}
                                />      
                            </div>
                        </div>
                    )}
                </HierarchyExplorer>
            }</FolderReader>  
        };
        let filtersComponents: FilterComponent[] = [
            {
                id: 'documentNumber',
                component:  
                    <div style={{marginLeft: 5, marginRight: 15}}>
                        <Label>{t('Doc.Number')}</Label>
                        <ReactTags
                            tags={documentNumberTags}
                            delimiters={[KeyCodes.comma, KeyCodes.enter]}
                            handleDelete={this.removeDocumentNumberTag}
                            handleAddition={this.addDocumentNumberTag}
                            placeholder="Press enter to search"
                            inputFieldPosition="top"
                            allowDragDrop={false}
                            autofocus={false}
                            classNames={{
                                tagInputField: styles.inputField,
                                selected: styles.tagInput,
                                tag: styles.tag,
                                remove: styles.remove
                            }}
                        />
                    </div>
            },
            {
                id: 'sheet',
                component:        
                    <SheetReader>{(reduxValue?: number) =>   
                        <>
                            <Label style={{marginLeft: 5}}>{t('Sheet')}</Label>
                            <NumericFormat
                                key="sheet"
                                customInput={TextField}
                                decimalScale={0}
                                value={(reduxValue) ? reduxValue : ''}
                                autoComplete={'off'}
                                onValueChange={(values) => {
                                    setSheet({value: values.floatValue});
                                    this.debouncedFetchDocuments();
                                }}
                                styles={{root: {marginLeft: 5, minWidth: 260}}}
                            />
                        </>
                    }</SheetReader>                             
            },
            {
                id: 'revision',
                component:  
                    <RevisionReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'revision'}
                            label={t("Revision")} 
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setRevision({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />    
                    }</RevisionReader>                   
            },
            ...(!_.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId')  ? [{
                id: 'agileNumber' as FiltersType,
                component:  
                    <AgileNumberReader>{(reduxValue?: string) => 
                        <TextField 
                            key={'agileNumber'}
                            label={t("Agile Number")} 
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setAgileNumber({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />    
                    }</AgileNumberReader>                        
            }] : []),  
            {
                id: 'clientNumber',
                component:
                    <ClientNumberReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'clientNumber'}
                            label={t('Client number')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setClientNumber({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />       
                    }</ClientNumberReader>                
            },
            ...(!_.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId')  ? [{
                id: 'tdNumber' as FiltersType,
                component:  
                    <TdNumberReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'tdNumber'}
                            label={t("TD Number")} 
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setTdNumber({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />       
                    }</TdNumberReader>                   
                }] : []),  
            ...(!_.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId')  ? [{
                id: 'publication' as FiltersType,
                component:  
                <TransmittalNumberReader>{(reduxValue?: number) =>   
                    <>                      
                        <Label style={{marginLeft: 5}}>{t('Publication')}</Label>
                        <Dropdown
                            key={'publication'}
                            placeholder={t('Select a publication') + '...'}
                            disabled={loadingPurposes}
                            options={publication_options}
                            onChange={(e, value) => {
                                setTransmittalNumber({
                                    value: value && value.key !== -1
                                        ? value.key as number
                                        : undefined
                                });

                                this.debouncedFetchDocuments();
                            }}
                            selectedKey={reduxValue ? reduxValue : null}
                            onRenderOption={(option) => (
                                <div
                                    onMouseEnter={(e) => e.stopPropagation()}
                                    onMouseMove={(e) => e.stopPropagation()}
                                >
                                    {option?.text}
                                </div>
                            )}
                            styles={{
                                root: { minWidth: 260 },
                                dropdownItemsWrapper: {
                                    maxHeight: 360,
                                    overflowY: 'auto'
                                }
                            }}
                        />   
                        {/* <NumericFormat
                            key="publication"
                            customInput={TextField}
                            decimalScale={0}
                            value={(reduxValue) ? reduxValue : ''}
                            autoComplete={'off'}
                            onValueChange={(values) => {
                                setTransmittalNumber({value: values.floatValue});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />                                            */}
                    </>
                }</TransmittalNumberReader>  
            }] : []),
            {
                id: 'purpose',
                component: 
                    <PurposeReader>{(reduxValue?: Purpose) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingPurposes && <Label>{t('Purpose')}</Label>}
                            {loadingPurposes && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>{t('Purpose')}</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <Dropdown
                                key={'purpose'}
                                placeholder={t('Select a purpose') + '...'}
                                disabled={loadingPurposes}
                                options={purposes_options}
                                onChange={(e, value) => {
                                    setPurpose({value: (value && value.key !== -1) ? _.find(purposes, p => p.id === value.key) : undefined});
                                    this.debouncedFetchDocuments();
                                }}
                                onRenderOption={(option) => (
                                    <div
                                        onMouseEnter={(e) => e.stopPropagation()}
                                        onMouseMove={(e) => e.stopPropagation()}
                                    >
                                        {option?.text}
                                    </div>
                                )}
                                selectedKey={(reduxValue) ? reduxValue.id : null}                              
                                styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                            />                   
                        </div> 
                    }</PurposeReader> 
            }, 
            {
                id: 'tdSubject' as FiltersType,
                component:
                    <TdSubjectReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'tdSubject'}
                            label={t('TD Subject')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setTDSubject({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />       
                    }</TdSubjectReader>                
            },
            {
                id: 'titleLine4Pl' as FiltersType,
                component:
                    <TitleLine4PlReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'titleLine4Pl'}
                            label={t('Title 1')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setTitleLine4Pl({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />       
                    }</TitleLine4PlReader>                
            },
            {
                id: 'titleLine5Pl' as FiltersType,
                component:
                    <TitleLine5PlReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'titleLine5Pl'}
                            label={t('Title 2')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setTitleLine5Pl({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />       
                    }</TitleLine5PlReader>                
            },
            {
                id: 'titleLine6Pl' as FiltersType,
                component:
                    <TitleLine6PlReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'titleLine6Pl'}
                            label={t('Title 3')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setTitleLine6Pl({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />       
                    }</TitleLine6PlReader>                
            },   
            ...(!isExternalApp && (historyName === 'reservedNumbers' || historyName === 'supplierMaterial') && suppliers && suppliers.length > 0 ? [{
                id: 'supplier' as FiltersType,
                component: 
                    <SupplierReader>{(reduxValue?: StakeHolder) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingStakeHolders && <Label>Supplier</Label>}
                            {loadingStakeHolders && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>Supplier</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <Dropdown
                                key={'supplier'}
                                placeholder='Select a supplier...'
                                disabled={loadingStakeHolders}
                                options={supplier_options}
                                onChange={(e, value) => {
                                    setSupplier({value: (value && value.key !== -1) ? _.find(suppliers, dt => dt.stakeHolderId === value.key) : undefined});
                                    this.debouncedFetchDocuments();
                                }}
                                onRenderOption={(option) => (
                                    <div
                                        onMouseEnter={(e) => e.stopPropagation()}
                                        onMouseMove={(e) => e.stopPropagation()}
                                    >
                                        {option?.text}
                                    </div>
                                )}
                                selectedKey={(reduxValue) ? reduxValue.stakeHolderId : null}                              
                                styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                            />                   
                        </div> 
                    }</SupplierReader>  
            }] : []),               
            ...(((!isExternalApp && (historyName === 'dashboard' || historyName === 'reservedNumbers' || historyName === 'supplierMaterial')) || (isExternalApp && (historyName === 'reservedNumbers' || historyName === 'publishMaterial'))) && suppliers && suppliers.length > 0 ? [{
                id: 'supplierDocumentNumber' as FiltersType,
                component: 
                    <SupplierDocumentNumberReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'supplierDocumentNumber'}
                            label={t('Supplier Doc.Number')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setSupplierDocumentNumber({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />       
                    }</SupplierDocumentNumberReader>  
            }] : []),                  
            ...(!isExternalApp && partners && partners.length > 0 ? [{
                id: 'partner' as FiltersType,
                component: 
                    <PartnerReader>{(reduxValue?: StakeHolder) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingStakeHolders && <Label>Partner</Label>}
                            {loadingStakeHolders && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>Partner</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <Dropdown
                                key={'partner'}
                                placeholder='Select a partner...'
                                disabled={loadingStakeHolders}
                                options={partner_options}
                                onChange={(e, value) => {
                                    setPartner({value: (value && value.key !== -1) ? _.find(partners, dt => dt.stakeHolderId === value.key) : undefined});
                                    this.debouncedFetchDocuments();
                                }}
                                onRenderOption={(option) => (
                                    <div
                                        onMouseEnter={(e) => e.stopPropagation()}
                                        onMouseMove={(e) => e.stopPropagation()}
                                    >
                                        {option?.text}
                                    </div>
                                )}
                                selectedKey={(reduxValue) ? reduxValue.stakeHolderId : null}                              
                                styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                            />                   
                        </div> 
                    }</PartnerReader>  
            }] : []),  
            ...(!isExternalApp && partners && partners.length > 0 ? [{
                id: 'partnerNumber' as FiltersType,
                component: 
                    <PartnerNumberReader>{(reduxValue?: string) =>   
                        <TextField 
                            key={'partnerNumber'}
                            label={t('Partner Number')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setPartnerNumber({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />     
                    }</PartnerNumberReader>  
            }] : []),  
            ...(daysToApproval > 0 ? [{
                id: 'approvalDate' as FiltersType,
                component: 
                    <ApprovalDateReader>{(reduxValue?: Date) =>   
                        <DatePicker
                            label={t('Approval Deadline')}
                            value={reduxValue}
                            onSelectDate={(date) => {
                                setApprovalDate({value: (date) ? date : undefined});
                                this.debouncedFetchDocuments();
                            }}
                            formatDate={formatDate}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        />    
                    }</ApprovalDateReader>  
            }] : []),  
            {
                id: 'pbs',
                component:
                    
                <HierarchyExplorer
                    readOnly={loadingPbs}
                    title={"PBS selector"}
                    items={pbs}
                    onSelect={(item, checked) => this.setPbsValueFunction(item, checked)}
                    selected={pbsFilter ? pbsFilter.map((pbsItem: Pbs) => pbsItem.name) : []}
                    selectedProperty={"name"}
                    isSelectable={() => { return true }}
                >
                    {(ref, onClick) => (
                        <div style={{ marginLeft: 5 }}>
                            {!loadingPbs && <Label>PBS</Label>}

                            {loadingPbs &&
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Label style={{ marginRight: 10 }}>PBS</Label>
                                    <Spinner size={SpinnerSize.small} />
                                </div>
                            }

                            <div
                                ref={ref}
                                onClick={onClick}
                                onFocus={onClick}
                                style={{ cursor: 'pointer' }}
                            >
                                <TagPicker
                                    selectedItems={
                                        pbsFilter
                                            ? pbsFilter.map((pbsItem: Pbs): ITag => ({
                                                key: pbsItem.id || pbsItem.name,
                                                name: pbsItem.name
                                            }))
                                            : []
                                    }
                                    onResolveSuggestions={() => []}
                                    onEmptyResolveSuggestions={() => []}
                                    onChange={(items?: ITag[]) => this.onPbsTagsChange(items)}
                                    inputProps={{
                                        readOnly: true,
                                        placeholder: pbsFilter && pbsFilter.length > 0
                                            ? ''
                                            : 'Select PBS'
                                    }}
                                    removeButtonAriaLabel="Remove PBS"
                                    styles={{
                                        root: {
                                            width: '100%'
                                        },
                                        text: {
                                            border: '1px solid #605e5c',
                                            minHeight: 32,
                                            cursor: 'pointer'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </HierarchyExplorer>
                    
            },
            {
                id: 'discipline',
                component: 
                    <div style={{marginLeft: 5}}>
                        {!loadingDisciplinesAndDocTypes && <Label>{t('Discipline')}</Label>}
                        {loadingDisciplinesAndDocTypes && 
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <Label style={{marginRight: 10}}>{t('Discipline')}</Label>
                                <Spinner size={SpinnerSize.small}/>
                            </div>
                        }
                        <Dropdown
                            key={'discipline'}
                            placeholder={t('Select a discipline') + '...'}
                            disabled={loadingDisciplinesAndDocTypes || disciplines.length === 0}
                            options={disciplines_options}
                            onChange={(e, value) => {
                                setDiscipline({value: (value && value.key !== -1) ? _.find(disciplines, dt => dt.id === value.key) : undefined});
                                this.debouncedFetchDocuments();
                            }}
                            onRenderOption={(option) => (
                                <div
                                    onMouseEnter={(e) => e.stopPropagation()}
                                    onMouseMove={(e) => e.stopPropagation()}
                                >
                                    {option?.text}
                                </div>
                            )}
                            selectedKey={(discipline) ? discipline.id : null}                              
                            styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                        />                   
                    </div> 
            },
            {
                id: 'docType',
                component: 
                    <DocTypeReader>{(reduxValue?: DocType) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingDisciplinesAndDocTypes && <Label style={{marginLeft: 18}}>{t('Doc Type')}</Label>}
                            {loadingDisciplinesAndDocTypes && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginLeft: 18, marginRight: 10}}>{t('Doc Type')}</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img src={CornerArrow} alt="Can't load search results" style={{marginRight: 5, color: getTheme(darkModeEnabled).palette.themePrimary, height: 20}}/>
                                <Dropdown
                                    key={'docType'}
                                    placeholder={t('Select a doc type') + '...'}
                                    disabled={loadingDisciplinesAndDocTypes || disciplines.length === 0 || !discipline}
                                    options={docType_options}
                                    onChange={(e, value) => {
                                        setDocType({value: (value && value.key !== -1 && discipline) ? _.find(discipline.docTypes, dt => dt.id === value.key) : undefined});
                                        this.debouncedFetchDocuments();
                                    }}
                                    onRenderOption={(option) => (
                                        <div
                                            onMouseEnter={(e) => e.stopPropagation()}
                                            onMouseMove={(e) => e.stopPropagation()}
                                        >
                                            {option?.text}
                                        </div>
                                    )}
                                    selectedKey={(reduxValue) ? reduxValue.id : null}                              
                                    styles={{root: {minWidth: 260, flexGrow: 1}, dropdownItemsWrapper: {maxHeight: 360}}}
                                />                   
                            </div>
                        </div>
                    }</DocTypeReader>   
            },
            ...(!isExternalApp ? [{
                id: 'customer' as FiltersType,
                component: 
                    <CustomerReader>{(reduxValue?: StakeHolder) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingStakeHolders && <Label>{t('Published to')}</Label>}
                            {loadingStakeHolders && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>{t('Published to')}</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <Dropdown
                                key={'customer'}
                                placeholder={t('Select a customer...')}
                                disabled={loadingStakeHolders}
                                options={customer_options}
                                onChange={(e, value) => {
                                    setCustomer({value: (value && value.key !== -1) ? _.find(customers, dt => dt.stakeHolderId === value.key) : undefined});
                                    this.debouncedFetchDocuments();
                                }}
                                onRenderOption={(option) => (
                                    <div
                                        onMouseEnter={(e) => e.stopPropagation()}
                                        onMouseMove={(e) => e.stopPropagation()}
                                    >
                                        {option?.text}
                                    </div>
                                )}
                                selectedKey={(reduxValue) ? reduxValue.stakeHolderId : null}                              
                                styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                            />                   
                        </div> 
                    }</CustomerReader>  
            }] : []),     
        ];
        filtersComponents = getContextualFilters([statusComponent, ...datesComponent, ...(selectedProject && selectedProject.isFolderPageActive && _.find(userProjectActions, a => a === 'ShowFolders') && historyName === 'dashboard' ? [folderComponent] : []), ...filtersComponents], historyName);
        return (isCallout && selectedFilter && selectedFilter) ? (selectedFilter !== 'dates_callout' ? _.filter(filtersComponents, f => f.id === selectedFilter) : [...datesComponent]) : filtersComponents;     
    }

   onRenderPbsSuffix: IRenderFunction<ITextFieldProps> = (props, defaultRender) => {
        const { pbsFilter } = this.props;
        return (
                <TooltipHost
                    directionalHint={DirectionalHint.rightCenter}
                    content={(pbsFilter && pbsFilter.length > 0) ? "Remove PBS" : ""}
                >
                    <div
                        onClick={
                            (pbsFilter && pbsFilter.length > 0)
                                ? (e) => {
                                    this.setPbsValueFunction(undefined);
                                    e.stopPropagation();
                                }
                                : () => {}
                        }
                    >
                        <FontIcon
                            iconName={"Cancel"}
                            style={{
                                cursor: (pbsFilter && pbsFilter.length > 0)
                                    ? "pointer"
                                    : "default"
                            }}
                        />
                    </div>
                </TooltipHost>
  
        );
    };

    setPbsValueFunction = (item?: any, checked?: boolean) => {
        const { setPbs, pbsFilter } = this.props;
        const currentPbs: Pbs[] = pbsFilter || [];

        if (!item) {
            setPbs({ value: undefined });
            this.debouncedFetchDocuments();
            return;
        }

        const updatedPbs = checked
            ? currentPbs.some((pbsItem: Pbs) => pbsItem.id === item.id)
                ? currentPbs
                : [...currentPbs, item]
            : currentPbs.filter(
                (pbsItem: Pbs) => pbsItem.id !== item.id
            );

        setPbs({
            value: updatedPbs.length > 0 ? updatedPbs : undefined
        });

        this.debouncedFetchDocuments();
    };

    onPbsTagsChange = (items?: ITag[]) => {
    const { setPbs, pbsFilter } = this.props;

        const selectedKeys = (items || []).map((tag: ITag) => String(tag.key));

        const updatedPbs = (pbsFilter || []).filter(
            (pbsItem: Pbs) =>
                selectedKeys.includes(String(pbsItem.id || pbsItem.name))
        );

        setPbs({
            value: updatedPbs.length > 0 ? updatedPbs : undefined
        });

        this.debouncedFetchDocuments();
    };
    
    getOtherFilters = (): FilterComponent[] => {
        const { isCallout, history, types, loadingTypes, loadingEntities, loadingEngPhases, entities, discipline, loadingStakeHolders, customers, t, userProjectActions, darkModeEnabled, suppliers,
                engPhases, disciplines, setType, setPurpose, setEngPhase, setEntity, setPwFilename, setCommented, setIsForInternalUse, setShowAllVersions, setPartner, setCustomer, setIgnorePurposes, setSupplier } = this.props;
        const historyName = getHistoryName(history);
        const styles = getClassNames(isCallout ? true : false, getTheme(darkModeEnabled));
        let type_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getTypesDropdownOptions(types)];
        let entities_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getEntityDropdownOptions(entities)];
        let engPhases_options: {key: number, text: string}[] = [{key: -1, text: 'None'}, ...getEngPhaseDropdownOptions(engPhases)];      
       
        let filtersComponents: FilterComponent[] = [
            {
                id: 'type',
                component: 
                    <TypeReader>{(reduxValue?: Type) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingTypes && <Label>Type</Label>}
                            {loadingTypes && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>Type</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <Dropdown
                                key={'type'}
                                placeholder={t('Select a type') + '...'}
                                disabled={loadingTypes}
                                options={type_options}
                                onChange={(e, value) => {
                                    setType({value: (value && value.key !== -1) ? _.find(types, dt => dt.id === value.key) : undefined});
                                    this.debouncedFetchDocuments();
                                }}
                                onRenderOption={(option) => (
                                    <div
                                        onMouseEnter={(e) => e.stopPropagation()}
                                        onMouseMove={(e) => e.stopPropagation()}
                                    >
                                        {option?.text}
                                    </div>
                                )}
                                selectedKey={(reduxValue) ? reduxValue.id : null}                              
                                styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                            />                   
                        </div> 
                    }</TypeReader>  
            },
            {
                id: 'engPhase',
                component: 
                    <EngPhaseReader>{(reduxValue?: EngPhase) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingEngPhases && <Label>{t('Eng.Phase')}</Label>}
                            {loadingEngPhases && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>{t('Eng.Phase')}</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <Dropdown
                                key={'engPhase'}
                                placeholder={t('Select an Eng.phase') + '...'}
                                disabled={loadingEngPhases}
                                options={engPhases_options}
                                onChange={(e, value) => {
                                    setEngPhase({value: (value && value.key !== -1) ? _.find(engPhases, p => p.id === value.key) : undefined});
                                    this.debouncedFetchDocuments();
                                }}
                                onRenderOption={(option) => (
                                    <div
                                        onMouseEnter={(e) => e.stopPropagation()}
                                        onMouseMove={(e) => e.stopPropagation()}
                                    >
                                        {option?.text}
                                    </div>
                                )}
                                selectedKey={(reduxValue) ? reduxValue.id : null}                              
                                styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                            />                   
                        </div> 
                    }</EngPhaseReader>   
            },   
            ...(!_.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId')  ? [{
                id: 'entity' as FiltersType,
                component: 
                    <EntityReader>{(reduxValue?: Entity) =>   
                        <div style={{marginLeft: 5}}>
                            {!loadingEntities && <Label>{t('Entity')}</Label>}
                            {loadingEntities && 
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Label style={{marginRight: 10}}>{t('Entity')}</Label>
                                    <Spinner size={SpinnerSize.small}/>
                                </div>
                            }
                            <Dropdown
                                key={'entity'}
                                placeholder={t('Select an entity') + '...'}
                                disabled={loadingEntities}
                                options={entities_options}
                                onChange={(e, value) => {
                                    setEntity({value: (value && value.key !== -1) ? _.find(entities, e => e.id === value.key) : undefined});
                                    this.debouncedFetchDocuments();
                                }}
                                onRenderOption={(option) => (
                                    <div
                                        onMouseEnter={(e) => e.stopPropagation()}
                                        onMouseMove={(e) => e.stopPropagation()}
                                    >
                                        {option?.text}
                                    </div>
                                )}
                                selectedKey={(reduxValue) ? reduxValue.id : null}                              
                                styles={{root: {minWidth: 260}, dropdownItemsWrapper: {maxHeight: 360}}}
                            />                   
                        </div> 
                    }</EntityReader> 
                
            }] : []),       
            {
                id: 'pwFilename',
                component:  
                    <PwFilenameReader>{(reduxValue?: string) => 
                        <TextField 
                            key={'pwFilename'}
                            label={t('PW Filename')}
                            autoComplete={'off'} 
                            value={reduxValue || ''} 
                            onChange={(e, value) => { 
                                setPwFilename({value});
                                this.debouncedFetchDocuments();
                            }}
                            styles={{root: {marginLeft: 5, minWidth: 260}}}
                        /> 
                    }</PwFilenameReader>                   
            },    
            
            {
                id: 'commented',
                component:
                    <CommentedReader>{(reduxValue: boolean) => 
                        <div style={{display: 'flex', alignItems: 'center', marginTop: 10}}>
                            <Checkbox 
                                checked={(reduxValue) ? reduxValue : false} 
                                onChange={(e, value) => {
                                    setCommented({value: (value) ? true : false});
                                    this.debouncedFetchDocuments();
                                }} 
                                styles={{root: {marginLeft: 5}}}
                            />                           
                            <Label styles={{root: {marginLeft: 5}}}>{t('Commented')}</Label>
                        </div> 
                    }</CommentedReader>     
            },
            {
                id: 'showAllVersions',
                component:
                    <ShowAllVersionsReader>{(reduxValue: boolean) => 
                        <div style={{display: 'flex', alignItems: 'center', marginTop: 10}}>
                            <Checkbox 
                                checked={(reduxValue) ? reduxValue : false} 
                                onChange={(e, value) => {
                                    setShowAllVersions({value: (value) ? true : false});
                                    this.debouncedFetchDocuments();
                                }} 
                                styles={{root: {marginLeft: 5}}}
                            />                           
                            <Label styles={{root: {marginLeft: 5}}}>{t('Show all versions')}</Label>
                        </div> 
                     }</ShowAllVersionsReader>   
            },
            ...(!isExternalApp ? [{ // !_.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId')
                id: 'isForInternalUse'as FiltersType,
                component:
                    <IsForInternalUseReader>{(reduxValue: boolean) => 
                        <div style={{display: 'flex', alignItems: 'center', marginTop: 10}}>
                            <Checkbox 
                                checked={(reduxValue) ? reduxValue : false} 
                                onChange={(e, value) => {
                                    setIsForInternalUse({value: (value) ? true : false});
                                    this.debouncedFetchDocuments();
                                }} 
                                styles={{root: {marginLeft: 5}}}
                            />                           
                            <Label styles={{root: {marginLeft: 5}}}>{t('Show TD cover page')}</Label>
                        </div> 
                    }</IsForInternalUseReader>   
            }] : []), 
            ...(historyName === 'pending' ? [{ 
                id: 'ignorePurposes'as FiltersType,
                component:
                    <IgnorePurposesReader>{(reduxValue: boolean) => 
                        <div style={{display: 'flex', alignItems: 'center', marginTop: 10}}>
                            <Checkbox 
                                checked={(reduxValue) ? reduxValue : false} 
                                onChange={(e, value) => {
                                    setIgnorePurposes({value: (value) ? true : false});
                                    setPurpose({value: undefined});
                                    this.debouncedFetchDocuments();
                                }} 
                                styles={{root: {marginLeft: 5}}}
                            />                           
                            <Label styles={{root: {marginLeft: 5}}}>{t('Show all docs')}</Label>
                        </div> 
                    }</IgnorePurposesReader>   
            }] : []), 
        ]
        filtersComponents = getContextualFilters(filtersComponents, historyName);
        return filtersComponents;     
    }

    render() {
        const { isCallout, selectedFilter, darkModeEnabled } = this.props;
        const styles = getClassNames(isCallout ? true : false, getTheme(darkModeEnabled));
        const genericComponent = this.getGenericComponent();
        const mainFilterComponents = this.getMainFilters();
        const otherFilterComponents = this.getOtherFilters();
        const dates = _.filter(mainFilterComponents, f => f.id === 'from' || f.id === 'to');
        const checkboxes = _.filter(otherFilterComponents, f => f.id === 'commented' || f.id === 'showAllVersions');
        return (
            <>
                {!isCallout && 
                    <Scrollbars id={'filters_scrollbar'} style={{ height: '87vh' }}>
                        <div className={styles.filtersContainer}>
                            <div key={'_generic'}>{genericComponent.component}</div>
                            {_.map(mainFilterComponents, (fc, index) => {
                                    return (fc.id !== 'from' && fc.id !== 'to' && fc.id !== 'commented' && fc.id!== 'showAllVersions') ? 
                                        <div key={index + '_o'}>{fc.component}</div> : 
                                        ((fc.id === 'from') ? 
                                            <div key={index + '_od'} style={{display: 'flex', alignItems: 'center'}}> {_.map(dates, (df, df_index) => { return <div key={df_index + '_d'} style={{width: '100%'}}>{df.component}</div>})}</div> : 

                                            ((fc.id === 'commented') ? 
                                                (<div key={index + '_od'} style={{display: 'flex', alignItems: 'center'}}> {_.map(checkboxes, (c, c_index) => { return <div key={c_index + '_c'} style={{width: '100%'}}>{c.component}</div>})}</div>) :
                                                <div key={'none_' + index}></div>
                                            )
                                        
                                        )
                            })}                        
                            <>
                                {/* <Separator/> */}
                                {_.map(otherFilterComponents, (fc, index) => {
                                    return (fc.id !== 'from' && fc.id !== 'to' && fc.id !== 'commented' && fc.id!== 'showAllVersions') ? 
                                        <div key={index + '_o'}>{fc.component}</div> : 
                                        ((fc.id === 'from') ? 
                                            <div key={index + '_od'} style={{display: 'flex', alignItems: 'center'}}> {_.map(dates, (df, df_index) => { return <div key={df_index + '_d'} style={{width: '100%'}}>{df.component}</div>})}</div> : 

                                            ((fc.id === 'commented') ? 
                                                (<div key={index + '_od'} style={{display: 'flex', alignItems: 'center'}}> {_.map(checkboxes, (c, c_index) => { return <div key={c_index + '_c'} style={{width: '100%'}}>{c.component}</div>})}</div>) :
                                                <div key={'none_' + index}></div>
                                            )
                                        
                                        )
                                })}
                            </>      
                        </div>
                    </Scrollbars>    
                }
                {isCallout &&               
                    <div className={styles.filtersContainer}>
                        {selectedFilter && selectedFilter !== 'dates_callout' &&
                            <>
                                {mainFilterComponents[0].component}                                                   
                            </>
                        }
                        {selectedFilter && selectedFilter === 'dates_callout' &&
                            <>
                                {mainFilterComponents[0].component}    
                                {mainFilterComponents[1].component}                                                   
                            </>
                        }
                    </div>
                }
            </>
        );
    }
}


const mapStateToProps = createStructuredSelector({
    userProjectActions: getSelectedProjectUserActions,
    statusValues: getStatusValues,
    types: getTypes,
    purposes: getPurposes,
    entities: getEntities,
    engPhases: getEngPhases,
    disciplines: getDisciplines,
    pbs: getPbs,
    discipline: getFilterDiscipline,
    from: getFilterFrom,
    to: getFilterTo,
    documentNumber: getFilterDocumentNumber,
    selectedProject: getSelectedProject,
    folders: getFolders,
    partners: getSelectedProjectPartners,
    suppliers: getSelectedProjectSuppliers,
    customers: getSelectedProjectCustomers,
    darkModeEnabled: getDarkModeEnabled,
    showAllDocs: getFilterIgnorePurposes,
    stakeholders: getStakeHolders,
    daysToApproval: getSelectedProjectDaysToApproval,
    pbsFilter: getFilterPbs,
    publicationsList: getPublicationsList,
    loadingStatus: (state) => getLoader('shared')(state).loadingStatus,
    loadingTypes: (state) => getLoader('shared')(state).loadingTypes,
    loadingEngPhases: (state) => getLoader('shared')(state).loadingEngPhases,
    loadingDisciplinesAndDocTypes: (state) => getLoader('shared')(state).loadingDisciplinesAndDocTypes,
    loadingPurposes: (state) => getLoader('projectShared')(state).loadingPurposes,
    loadingEntities: (state) => getLoader('projectShared')(state).loadingEntities,
    loadingPbs: (state) => getLoader('projectShared')(state).loadingPbs,
    loadingFolders: (state) => getLoader('projectShared')(state).loadingFolders,
    loadingStakeHolders: (state) => getLoader('projectShared')(state).loadingStakeHolders,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({ 
        setStatus: CommandActions.setStatus,
        setDocumentNumber: CommandActions.setDocumentNumber,
        setAgileNumber: CommandActions.setAgileNumber,       
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        setSheet: CommandActions.setSheet,
        setRevision: CommandActions.setRevision,
        setClientNumber: CommandActions.setClientNumber,
        setTdNumber: CommandActions.setTdNumber,
        setTransmittalNumber: CommandActions.setTransmittalNumber,
        setType: CommandActions.setType,
        setPurpose: CommandActions.setPurpose,
        setEntity: CommandActions.setEntity,
        setEngPhase: CommandActions.setEngPhase,
        setFrom: CommandActions.setFrom,
        setTo: CommandActions.setTo,
        setPwFilename: CommandActions.setPwFilename,
        setCommented: CommandActions.setCommented,
        setDiscipline: CommandActions.setDiscipline,
        setDocType: CommandActions.setDocType,
        setPbs: CommandActions.setPbs,
        setFolder: CommandActions.setFolder,
        setIsForInternalUse: CommandActions.setIsForInternalUse,
        setShowAllVersions: CommandActions.setShowAllVersions,
        setPartner: CommandActions.setPartner,
        setPartnerNumber: CommandActions.setPartnerNumber,
        setCustomer: CommandActions.setCustomer,
        openGenericModal: ModalActions.CommandActions.openModal,
        setTDSubject: CommandActions.setTDSubject,
        setTitleLine4Pl: CommandActions.setTitleLine4Pl,
        setTitleLine5Pl: CommandActions.setTitleLine5Pl,
        setTitleLine6Pl: CommandActions.setTitleLine6Pl,
        setGeneric: CommandActions.setGeneric,
        setIgnorePurposes: CommandActions.setIgnorePurposes,
        setApprovalDate: CommandActions.setApprovalDate,
        setSupplier: CommandActions.setSupplier,
        setSupplierDocumentNumber: CommandActions.setSupplierDocumentNumber
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)((withTranslation()(withRouter(FiltersClass))));
